import React, { useContext } from "react"
import styled from "styled-components"

import { Content, Title, Subtitle } from "Styles"
import { theme } from "Theme"

import { ThemeContext, ActionButton, ActionButtonAlt, LinkButtonAlt } from "Components"

const Wrapper = styled.section`
  width: 100%;
  color: ${({ mode }) => (mode === "dark" ? theme.colors.white.base : theme.colors.black.base)};
  background-color: ${({ mode }) => (mode === "dark" ? theme.colors.black.base : theme.colors.white.base)};
  border-color: ${({ mode }) => (mode === "light" ? theme.colors.white.base : theme.colors.black.base)};
  border-radius: ${theme.borderRadius.ui};
  overflow: hidden;
  box-shadow: ${theme.shadow.feature.small.default};
  z-index: 3;
  display: grid;
  min-height: 260px;
  align-items: center;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    ${({ image }) => (image ? `grid-template-columns: 33% 1fr;` : `grid-template-columns: 1fr;`)};
  }
  @media (min-width: ${theme.breakpoints.l}) {
    ${({ image }) => (image ? `grid-template-columns: 33% 1fr;` : `grid-template-columns: 1fr;`)};
  }
  max-width: ${theme.layout.base};
`

// const StyledBackgroundImage = styled(GbiBridged)`
//   display: none;
//   @media (min-width: ${theme.breakpoints.s}) {
//   }
//   @media (min-width: ${theme.breakpoints.m}) {
//     display: block;
//   }
//   @media (min-width: ${theme.breakpoints.l}) {
//   }
// `

const FeaturedSectionOverflow = ({
  track,
  dark,
  title,
  subtitle,
  image,
  children,
  cta_url1_text,
  cta_url1,
  cta_url2_text,
  cta_url2,
  cta_action1_text,
  cta_action1,
  cta_action2_text,
  cta_action2,
}) => {
  const { mode } = useContext(ThemeContext)
  console.log({ image })
  // const track = this
  return (
    // <FullWrapper>
    <Wrapper image={image} mode={dark ? "dark" : mode}>
      {/* {image && <StyledBackgroundImage title={title} image={image} dark={dark ? 1 : undefined} />} */}
      <Content style={{ padding: "2rem" }}>
        {title && title !== "null" && <Title className={!subtitle ? "mb-0" : ""}>{title}</Title>}
        {subtitle && subtitle !== "null" && <Subtitle className={!children ? "mb-0" : ""}>{subtitle}</Subtitle>}
        {children && children}
        {(cta_action1_text || cta_action2_text || cta_url1_text || cta_url2_text) && (
          <div style={{ marginTop: "1rem" }}>
            {cta_action1 && cta_action1_text && cta_action1_text !== "null" && (
              <ActionButton onClick={cta_action1} track={track} title={`${title} | ${cta_action1_text}`}>
                {cta_action1_text}
              </ActionButton>
            )}
            {cta_action2 && cta_action2_text && cta_action2_text !== "null" && (
              <ActionButtonAlt onClick={cta_action2} track={track} title={`${title} | ${cta_action2_text}`}>
                {cta_action2_text}
              </ActionButtonAlt>
            )}
            {cta_url1 && cta_url1_text && cta_url1_text !== "null" && (
              <LinkButtonAlt to={cta_url1} track={track} title={`${title} | ${cta_url1_text}`}>
                {cta_url1_text}
              </LinkButtonAlt>
            )}
            {cta_url2 && cta_url2_text && cta_url2_text !== "null" && (
              <LinkButtonAlt to={cta_url2} track={track} title={`${title} | ${cta_url2_text}`}>
                {cta_url2_text}
              </LinkButtonAlt>
            )}
          </div>
        )}
      </Content>
    </Wrapper>
    // </FullWrapper>
  )
}

export default FeaturedSectionOverflow
